import React from 'react';

export default function Card({ 
  children, 
  className = '', 
  hover = false,
  padding = 'default',
  ...props 
}) {
  const paddings = {
    none: '',
    small: 'p-4',
    default: 'p-6',
    large: 'p-8'
  };

  return (
    <div
      className={`
        card
        ${hover ? 'card-hover cursor-pointer' : ''}
        ${paddings[padding]}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
}

export function MetricCard({ title, value, change, icon: Icon, trend }) {
  return (
    <Card className="p-6">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-text-muted">{title}</p>
          <p className="mt-1 text-2xl font-bold text-text-primary">{value}</p>
          {change && (
            <p className={`mt-1 text-sm ${trend === 'up' ? 'text-success' : trend === 'down' ? 'text-red-500' : 'text-text-muted'}`}>
              {trend === 'up' ? '↑' : trend === 'down' ? '↓' : ''} {change}
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-3 rounded-xl bg-primary/10">
            <Icon className="w-6 h-6 text-primary" />
          </div>
        )}
      </div>
    </Card>
  );
}
